import { METRIC } from './conversion-constants';

/**
 * Unit conversion helper functions for common geometric operations.
 * Provides type-safe, self-documenting conversion utilities.
 */

/**
 * Mathematical constant for converting between diameter and radius
 * radius = diameter / 2
 * diameter = radius * 2
 */
const DIAMETER_TO_RADIUS_FACTOR = 2;

/**
 * Convert millimeters to meters
 */
export function convertMillimetersToMeters(millimeters: number): number {
  return millimeters / METRIC.SCALE.baseToMilli;
}

/**
 * Convert meters to millimeters
 */
export function convertMetersToMillimeters(meters: number): number {
  return meters * METRIC.SCALE.baseToMilli;
}

/**
 * Convert diameter to radius
 */
export function convertDiameterToRadius(diameter: number): number {
  return diameter / DIAMETER_TO_RADIUS_FACTOR;
}

/**
 * Convert diameter in millimeters to radius in meters
 */
export function convertMillimeterDiameterToMeterRadius(
  diameterMm: number
): number {
  return convertMillimetersToMeters(convertDiameterToRadius(diameterMm));
}

/**
 * Convert radius in meters to diameter in millimeters
 */
export function convertMeterRadiusToMillimeterDiameter(
  radiusM: number
): number {
  return convertMetersToMillimeters(radiusM * DIAMETER_TO_RADIUS_FACTOR);
}

/**
 * Convert a 3D point from millimeters to meters
 */
export function convertPoint3DMillimetersToMeters(
  x: number,
  y: number,
  z: number
): { x: number; y: number; z: number } {
  return {
    x: convertMillimetersToMeters(x),
    y: convertMillimetersToMeters(y),
    z: convertMillimetersToMeters(z),
  };
}

/**
 * Convert a 3D point from meters to millimeters
 */
export function convertPoint3DMetersToMillimeters(
  x: number,
  y: number,
  z: number
): { x: number; y: number; z: number } {
  return {
    x: convertMetersToMillimeters(x),
    y: convertMetersToMillimeters(y),
    z: convertMetersToMillimeters(z),
  };
}
